import type { ComponentProps, ReactNode } from "react";
import { SeoHead } from "@/components/seo/SeoHead";
import { PageContainer } from "@/shared/layout/PageContainer";
import { Footer } from "@/shared/sections/Footer";

type MarketingPageProps = ComponentProps<typeof SeoHead> & {
  /** The page's hero and sections; the footer follows them. */
  children: ReactNode;
};

/** A public marketing page: its SEO head, then the `<main>` page column closed by the site footer. */
export const MarketingPage = ({ metadata, structuredData, children }: MarketingPageProps) => (
  <>
    <SeoHead metadata={metadata} structuredData={structuredData} />
    <main className="flex min-h-screen w-full flex-col items-center bg-(--color-background) text-(--color-text-primary)">
      <PageContainer>
        {children}
        <Footer />
      </PageContainer>
    </main>
  </>
);
